import React, { FunctionComponent } from 'react';
import { DataCategory, DataValueCompanyPageStories } from '../../../types/companyDetail';

type Props = {
  id: number;
  companyId: number;
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageStories;
  updatedAt: string;
  image: {
    url: string;
  } | null;
  postTitle: string;
};

export const Presentation: FunctionComponent<Props> = ({
  id,
  companyId,
  dataCategory,
  dataValue,
  updatedAt,
  image,
  postTitle,
}) => {
  return (
    <a
      href={`/companies/${companyId}/story_show?post_id=${id}`}
      target="_blank"
      rel="noreferrer"
      className="company__page__recruitments__wrapper__item gtm-story-view-count"
      data-event-name='story on screen'
      data-event="click"
      data-category={dataCategory}
      data-value={dataValue.selfStories}
    >
      <div className="company__page__recruitments__wrapper__item--cover story">
        {image && image?.url && (
          <img src={image?.url} alt={`${postTitle || 'ストーリー'} のロゴ写真`} />
        )}
        <div className="company__page__recruitments__wrapper__item--cover--mask">
          <p>{updatedAt}</p>
          <p>{postTitle}</p>
        </div>
      </div>
    </a>
  );
};
